/* =============================================
   LW Gallery - More Nutrition Style v10
   ============================================= */
(function () {
  'use strict';
  var BP = 750;
  var isMobile = window.innerWidth < BP;

  function svg(dir, s) {
    s = s || 16;
    var p = dir === 'prev' ? '15 18 9 12 15 6' : '9 18 15 12 9 6';
    return '<svg width="'+s+'" height="'+s+'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="'+p+'"></polyline></svg>';
  }
  function xSvg(s) {
    s = s || 22;
    return '<svg width="'+s+'" height="'+s+'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
  }

  /* ══════════════════════════════════════════════════════════════════════
     GROSSANSICHT: SOFORT AUF, DANN SCHARF (Max, 29.09.2026)
     "wenn man ein bild anklickt auf der pdp, dann oeffnet das zu langsam ca
     3 sek und wenn man auf die naechste seite skippt, das dauert auch zu
     lang ca 5 sek"

     Ursache, an der Live-Seite nachgelesen: die Grossansicht hat jedes Bild
     ueber `&width=1500` nachgeladen. 1500 steht in KEINER Groessenliste des
     Themes (die Galerie fordert 246 ... 1946 aus `widths`), also war jede
     Anfrage eine Groesse, die das Shopify-CDN erst rechnen musste, und die
     Grossansicht blieb bis dahin leer. Auf dem Handy kamen beim Oeffnen
     gleich alle Bilder in dieser Groesse auf einmal dazu und stellten die
     eine Datei an, auf die der Kunde wartete, hinten an.

     Seitdem: 1. das schon geladene Bild der Galerie steht SOFORT da (bei der
     Galerie-Vorschau zur Not die Miniatur, auf Endgroesse gestellt), 2. das
     scharfe Bild kommt in einer Breite AUS DER GALERIE-LISTE nach und ersetzt
     es, sobald es gezeichnet werden kann, 3. erst danach werden Vorgaenger und
     Nachfolger mit niedriger Prioritaet vorgeladen, nicht mehr alle 13.
     ⚠️ WIDTHS muss zu `widths:` in snippets/product-thumbnail.liquid passen. ══ */
  var WIDTHS = [246, 493, 600, 713, 823, 990, 1100, 1206, 1346, 1426, 1646, 1946];
  var MAXW = 1426;
  function snap(px) {
    px = Math.min(px, MAXW);
    for (var i = 0; i < WIDTHS.length; i++) if (WIDTHS[i] >= px) return WIDTHS[i];
    return MAXW;
  }
  function aspect(img) {
    var w = +img.getAttribute('width'), h = +img.getAttribute('height');
    if (w > 0 && h > 0) return w / h;
    return img.naturalWidth > 0 && img.naturalHeight > 0 ? img.naturalWidth / img.naturalHeight : 1;
  }
  /* Scharfe Fassung: Breite passend zur Anzeigebox, aus der Liste der Galerie. */
  function bildUrl(img, boxW, boxH) {
    var src = img.getAttribute('src') || '';
    if (!/[?&]width=\d+/.test(src)) return src;
    var need = Math.min(boxW, boxH * aspect(img)) * Math.min(window.devicePixelRatio || 1, 3);
    return src.replace(/([?&])width=\d+/, '$1width=' + snap(need));
  }
  var pool = {};
  function laden(url, cb, niedrig) {
    if (!url) return;
    var e = pool[url];
    if (!e) {
      e = pool[url] = { da: false, cbs: [] };
      var i = new Image();
      if (niedrig && 'fetchPriority' in i) i.fetchPriority = 'low';
      e.img = i;
      var fertig = function () {
        e.da = true;
        var l = e.cbs; e.cbs = [];
        for (var k = 0; k < l.length; k++) l[k]();
      };
      i.onload = function () { (i.decode ? i.decode() : Promise.resolve()).then(fertig, fertig); };
      i.onerror = function () { delete pool[url]; };
      i.src = url;
    }
    if (cb) { if (e.da) cb(); else e.cbs.push(cb); }
  }
  /* Zeigt `url` in el: fertig geladen sofort, sonst zuerst die schon vorhandene
     Vorschau und danach, sobald es geht, die scharfe Fassung. */
  function zeige(el, s, thumb, url) {
    if (!url) return;
    el._want = url;
    var e = pool[url];
    if (e && e.da) { el.src = url; return; }
    var ph = '';
    if (s && s.complete && s.naturalWidth > 0) ph = s.currentSrc;
    else if (thumb && thumb.complete && thumb.naturalWidth > 0) ph = thumb.currentSrc;
    if (ph) el.src = ph;
    laden(url, function () { if (el._want === url) el.src = url; });
  }
  function thumbImg(i) {
    var li = document.querySelectorAll('.thumbnail-list .thumbnail-list__item')[i];
    return li ? li.querySelector('img') : null;
  }

  /* ══════════════════════════════════════════════════════════════════════
     ERSTES BILD: KEIN PFEIL NACH LINKS
     Von Max am 13.08.2026. Beim ersten Bild soll der Kunde sehen, dass er
     am Anfang steht - ein Pfeil nach links, der ihn ans ENDE der Reihe
     springen laesst, sagt genau das Gegenteil. Ab Bild 2 sind wieder beide
     Pfeile da, dort ist "zurueck" ja eine echte Richtung.

     Diese eine Funktion bedient alle vier Pfeilpaare der Seite; die CSS-Regel
     zu .lw-arrow--off steht in lw-gallery-arrows.css und erklaert, warum
     visibility und nicht display.

     ⚠️ Der Pfeil nach RECHTS bleibt beim letzten Bild bewusst stehen und
     springt weiter auf Bild 1. Danach war nicht gefragt, und die Runde
     vorwaerts ist die einzige, die der Kunde von sich aus sucht. Wer sie
     auch abschalten will: dieselbe Funktion, idx >= tot-1. ══════════════ */
  function firstOff(btn, idx) {
    if (btn) btn.classList.toggle('lw-arrow--off', idx <= 0);
  }

  /* =================== DESKTOP =================== */
  function initDesktop() {
    var mg = document.querySelector('media-gallery');
    if (!mg) return;
    var vw = mg.querySelector('[id*="GalleryViewer"]');
    if (!vw) return;
    var ml = vw.querySelector('.product__media-list');
    if (!ml) return;
    var ob = vw.querySelector('.slider-buttons');
    if (ob) ob.style.display = 'none';
    if (document.getElementById('lw-arrow-overlay')) return;

    var ov = document.createElement('div');
    ov.id = 'lw-arrow-overlay';
    /* --off schon im Markup: die Galerie startet immer auf Bild 1, und show(0)
       weiter unten wuerde die Klasse zwar ohnehin setzen - aber erst nach dem
       ersten Frame. Ein kurz aufblitzender Pfeil ist genau das, was hier weg
       soll. */
    ov.innerHTML = '<button class="lw-arrow lw-arrow--prev lw-arrow--off">'+svg('prev')+'</button><button class="lw-arrow lw-arrow--next">'+svg('next')+'</button>';
    var gut = vw.querySelector('.slider-mobile-gutter') || vw;
    gut.style.position = 'relative';
    gut.appendChild(ov);

    function items() { return Array.from(ml.querySelectorAll('.product__media-item')); }
    function aIdx() { var l=items(); for(var i=0;i<l.length;i++) if(l[i].classList.contains('is-active')) return i; return 0; }

    function show(idx) {
      var l = items();
      if (idx<0||idx>=l.length) return;
      /* Einzige Stelle, an der sich der Desktop-Index aendert - Pfeile,
         Thumbnails und die Lightbox laufen alle hier durch. */
      firstOff(ov.querySelector('.lw-arrow--prev'), idx);
      for (var i=0;i<l.length;i++) {
        l[i].style.display = i===idx ? '' : 'none';
        l[i].classList.toggle('is-active', i===idx);
        if (i===idx) l[i].classList.remove('scroll-trigger--offscreen');
      }
      var th = document.querySelectorAll('.thumbnail-list .thumbnail-list__item');
      for (var j=0;j<th.length;j++) {
        th[j].classList.toggle('is-active', j===idx);
        var b = th[j].querySelector('button');
        if (b) j===idx ? b.setAttribute('aria-current','true') : b.removeAttribute('aria-current');
      }
    }

    var th = document.querySelectorAll('.thumbnail-list .thumbnail-list__item');
    for (var t=0;t<th.length;t++) (function(i){
      var b=th[i].querySelector('button');
      if(b) b.addEventListener('click',function(e){e.preventDefault();e.stopImmediatePropagation();show(i);},true);
    })(t);

    ov.querySelector('.lw-arrow--prev').addEventListener('click',function(e){e.preventDefault();e.stopPropagation();var n=items().length,i=aIdx();show(i<=0?n-1:i-1);});
    ov.querySelector('.lw-arrow--next').addEventListener('click',function(e){e.preventDefault();e.stopPropagation();var n=items().length,i=aIdx();show(i>=n-1?0:i+1);});

    show(0);

    /* Block Dawn zoom */
    mg.addEventListener('click',function(e){
      var t=e.target;
      if(t.tagName==='IMG'&&t.closest('.product__media-item')&&!t.closest('.thumbnail-list')){
        e.preventDefault();e.stopImmediatePropagation();
        openLB(aIdx());return;
      }
      var el=t;while(el&&el!==mg){
        if(el.classList&&(el.classList.contains('product__modal-opener')||el.classList.contains('product__media-toggle'))){
          e.preventDefault();e.stopImmediatePropagation();return;
        }
        el=el.parentElement;
      }
    },true);

    /* Desktop Lightbox */
    /* Hoehe der Rahmenteile ausser dem Bild: Kopf 46 (10 Polster + 36 Knopf), Bildpolster 8, Zaehler 34
       (14px Schrift + 4/10 Polster), aufgerundet. Die Box ist 92vh hoch und schneidet mit overflow:hidden
       ab: mit 84vh Bild (= 756 bei 900px Fensterhoehe) blieben 72px fuer 88px Rahmen, der Zaehler fiel heraus. */
    var LB_CHROME=96;
    function openLB(si) {
      var all=items(),tot=all.length,ci=si;

      /* Backdrop — ALL styles inline to bypass theme CSS */
      var bd=document.createElement('div');
      bd.style.cssText = 'position:fixed !important;top:0 !important;left:0 !important;right:0 !important;bottom:0 !important;z-index:2147483646 !important;background:rgba(0,0,0,0.75) !important;cursor:pointer !important;display:block !important;';

      var lb=document.createElement('div');lb.id='lw-lightbox';
      lb.style.cssText = 'position:fixed !important;top:50% !important;left:50% !important;transform:translate(-50%,-50%) !important;max-width:90vw !important;max-height:92vh !important;z-index:2147483647 !important;background:#fff !important;border-radius:16px !important;display:flex !important;flex-direction:column !important;align-items:center !important;box-shadow:0 10px 60px rgba(0,0,0,0.4) !important;overflow:hidden !important;';

      var hd=document.createElement('div');hd.id='lw-lightbox-header';
      var cb=document.createElement('button');cb.id='lw-lightbox-close';cb.innerHTML=xSvg(22);
      hd.appendChild(cb);

      var wr=document.createElement('div');wr.id='lw-lightbox-img-wrap';
      var im=document.createElement('img');im.id='lw-lightbox-img';
      im.style.cssText = 'max-height:calc(92vh - '+LB_CHROME+'px) !important;max-width:88vw !important;display:block !important;border-radius:8px !important;user-select:none !important;';
      wr.appendChild(im);

      var ar=document.createElement('div');ar.id='lw-lightbox-arrows';
      ar.innerHTML='<button class="lw-lb-arrow lw-lb-arrow--prev">'+svg('prev')+'</button><button class="lw-lb-arrow lw-lb-arrow--next">'+svg('next')+'</button>';
      wr.appendChild(ar);

      var ct=document.createElement('div');ct.id='lw-lightbox-counter';

      lb.appendChild(hd);lb.appendChild(wr);lb.appendChild(ct);

      /* show(i) setzt den Pfeil der Galerie dahinter, ar den der Lightbox -
         zwei Paare, beide muessen mit. */
      /* Anzeigebox = max-width 88vw abzueglich Polster, Hoehe = 92vh der Box minus Rahmen (hoechstens 84vh). Groesse explizit setzen,
         damit die Vorschau (kleinere Datei) nicht in Miniatur erscheint und beim Schaerfen springt. */
      function boxW(){return window.innerWidth*0.88-28;}
      function boxH(){return Math.min(window.innerHeight*0.84,window.innerHeight*0.92-LB_CHROME);}
      function nachbarn(i){
        for(var d=1;d>=-1;d-=2){
          var s2=all[(i+d+tot)%tot].querySelector('img');
          if(s2)laden(bildUrl(s2,boxW(),boxH()),null,true);
        }
      }
      function ld(i){
        firstOff(ar.querySelector('.lw-lb-arrow--prev'),i);
        var s=all[i].querySelector('img');
        if(s){
          var a=aspect(s),w=Math.min(boxW(),boxH()*a);
          im.style.setProperty('width',Math.round(w)+'px','important');
          im.style.setProperty('height',Math.round(w/a)+'px','important');
          var u=bildUrl(s,boxW(),boxH());
          zeige(im,s,thumbImg(i),u);
          laden(u,function(){nachbarn(i);});
        }
        ct.textContent=(i+1)+' / '+tot;show(i);
      }

      function cls(){bd.remove();lb.remove();document.body.style.overflow='';document.removeEventListener('keydown',kd);}

      function kd(e){
        if(e.key==='Escape')cls();
        else if(e.key==='ArrowLeft'){ci=ci<=0?tot-1:ci-1;ld(ci);}
        else if(e.key==='ArrowRight'){ci=ci>=tot-1?0:ci+1;ld(ci);}
      }

      cb.addEventListener('click',cls);
      bd.addEventListener('click',cls);
      document.addEventListener('keydown',kd);

      ar.querySelector('.lw-lb-arrow--prev').addEventListener('click',function(e){e.stopPropagation();ci=ci<=0?tot-1:ci-1;ld(ci);});
      ar.querySelector('.lw-lb-arrow--next').addEventListener('click',function(e){e.stopPropagation();ci=ci>=tot-1?0:ci+1;ld(ci);});

      /* Drag swipe */
      var dx=0,dr=false;
      im.addEventListener('mousedown',function(e){dx=e.clientX;dr=true;e.preventDefault();});
      document.addEventListener('mouseup',function(e){if(!dr)return;dr=false;var d=dx-e.clientX;if(Math.abs(d)>60){if(d>0)ci=ci>=tot-1?0:ci+1;else ci=ci<=0?tot-1:ci-1;ld(ci);}});

      document.body.appendChild(bd);document.body.appendChild(lb);
      document.body.style.overflow='hidden';
      ld(si);
    }
  }

  /* =================== MOBILE =================== */
  function initMobile() {
    var mg = document.querySelector('media-gallery');
    if (!mg) return;
    var vw = mg.querySelector('[id*="GalleryViewer"]');
    if (!vw) return;
    var ml = vw.querySelector('.product__media-list');
    if (!ml) return;

    var allItems = ml.querySelectorAll('.product__media-item');
    for (var i=0;i<allItems.length;i++) allItems[i].style.display='';
    var tot = allItems.length;
    if (tot<=1) return;
    if (document.getElementById('lw-mobile-progress')) return;

    var ob = vw.querySelector('.slider-buttons');
    if (ob) ob.style.display='none';

    var segW = 100/tot;

    /* === Progress bar (Track + Bar child) === */
    var progressRow = document.createElement('div');
    progressRow.id = 'lw-mobile-progress';
    progressRow.style.cssText = 'display:flex !important;align-items:center;gap:12px;padding:12px 20px 0;';

    var track = document.createElement('div');
    track.id = 'lw-mobile-progress-track';
    track.style.cssText = 'flex:1;height:4px;border-radius:2px;background:#ddd;position:relative;';

    var bar = document.createElement('div');
    bar.id = 'lw-mobile-progress-bar';
    bar.style.cssText = 'display:block !important;position:absolute;top:0;left:0;height:4px;width:'+segW+'%;background:#333;border-radius:2px;transition:left 0.3s ease;';
    track.appendChild(bar);

    var counter = document.createElement('div');
    counter.id = 'lw-mobile-counter';
    counter.style.cssText = 'font-size:14px;font-weight:600;color:#333;white-space:nowrap;';
    counter.textContent = '1/'+tot;

    progressRow.appendChild(track);
    progressRow.appendChild(counter);
    mg.parentNode.insertBefore(progressRow, mg.nextSibling);

    /* === Pfeile FIXIERT auf slider-gutter zentriert === */
    var sliderGutter = vw.querySelector('.slider-mobile-gutter') || vw;
    sliderGutter.style.position = 'relative';

    var prevBtn = document.createElement('button');
    /* --off von Anfang an, siehe die Begruendung bei firstOff: die Seite
       startet auf Bild 1, und updateUI() unten bestaetigt das nur noch. */
    prevBtn.className = 'lw-mob-arrow-fixed lw-arrow--off';
    prevBtn.innerHTML = svg('prev');
    prevBtn.style.cssText = 'position:absolute;left:6px;top:50%;transform:translateY(-50%);z-index:20;width:44px;height:44px;background:#fff;border-radius:50%;border:none;box-shadow:0 2px 8px rgba(0,0,0,0.15);cursor:pointer;display:flex;align-items:center;justify-content:center;color:#222;-webkit-tap-highlight-color:transparent;';

    var nextBtn = document.createElement('button');
    nextBtn.className = 'lw-mob-arrow-fixed';
    nextBtn.innerHTML = svg('next');
    nextBtn.style.cssText = 'position:absolute;right:6px;top:50%;transform:translateY(-50%);z-index:20;width:44px;height:44px;background:#fff;border-radius:50%;border:none;box-shadow:0 2px 8px rgba(0,0,0,0.15);cursor:pointer;display:flex;align-items:center;justify-content:center;color:#222;-webkit-tap-highlight-color:transparent;';

    sliderGutter.appendChild(prevBtn);
    sliderGutter.appendChild(nextBtn);

    /* === Scroll tracking === */
    function getCurIdx() {
      var sl=ml.scrollLeft, sw=ml.scrollWidth-ml.clientWidth;
      if(sw<=0) return 0;
      return Math.round((sl/sw)*(tot-1));
    }

    function updateUI() {
      var idx = getCurIdx();
      counter.textContent = (idx+1)+'/'+tot;
      bar.style.left = (idx * segW) + '%';
      /* Auf dem Handy fuehrt JEDER Weg ueber den Scroll-Zuhoerer: Pfeil,
         Wisch, Sprung aus dem Zoom-Sheet. Deshalb reicht diese eine Stelle. */
      firstOff(prevBtn, idx);
    }

    var sTO;
    ml.addEventListener('scroll',function(){clearTimeout(sTO);sTO=setTimeout(updateUI,30);},{passive:true});
    /* Startzustand einmal aktiv setzen: ohne Scroll feuert der Zuhoerer nie,
       und eine Variante mit eigenem Bild kann die Liste schon verschoben
       ausliefern - dann steht die Seite eben nicht auf Index 0. */
    updateUI();

    function scrollTo(idx) {
      if(idx<0||idx>=tot) return;
      var t=allItems[idx];
      ml.scrollTo({left:t.offsetLeft-(ml.clientWidth-t.offsetWidth)/2,behavior:'smooth'});
    }

    prevBtn.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();var i=getCurIdx();scrollTo(i<=0?tot-1:i-1);});
    nextBtn.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();var i=getCurIdx();scrollTo(i>=tot-1?0:i+1);});

    /* === Dawn zoom block + tap-to-zoom === */
    mg.addEventListener('click',function(e){
      var t=e.target;
      if(t.tagName==='IMG'&&t.closest('.product__media-item')){
        e.preventDefault();e.stopImmediatePropagation();
        openSheet(getCurIdx());return;
      }
      var el=t;while(el&&el!==mg){
        if(el.classList&&(el.classList.contains('product__modal-opener')||el.classList.contains('product__media-toggle'))){
          e.preventDefault();e.stopImmediatePropagation();return;
        }
        el=el.parentElement;
      }
    },true);

    /* === Bottom-Sheet Zoom mit Slide-Animation === */
    function openSheet(si) {
      var ci = si;

      /* Backdrop — ALL styles inline to bypass theme CSS */
      var bd = document.createElement('div');
      bd.style.cssText = 'position:fixed !important;top:0 !important;left:0 !important;right:0 !important;bottom:0 !important;z-index:2147483646 !important;background:rgba(0,0,0,0.6) !important;display:block !important;-webkit-tap-highlight-color:transparent !important;';

      var sh = document.createElement('div');
      sh.id = 'lw-zoom-sheet';
      sh.style.cssText = 'position:fixed !important;left:0 !important;right:0 !important;bottom:0 !important;z-index:2147483647 !important;background:#fff !important;border-radius:20px 20px 0 0 !important;max-height:75vh !important;display:flex !important;flex-direction:column !important;box-shadow:0 -4px 30px rgba(0,0,0,0.15) !important;animation:lw-sheet-up 0.3s ease !important;';

      /* Header */
      var hd = document.createElement('div');
      hd.id = 'lw-zoom-sheet-header';
      var cb = document.createElement('button');
      cb.id = 'lw-zoom-close';
      cb.innerHTML = xSvg(18);
      hd.appendChild(cb);

      /* Bild + Pfeile */
      var wr = document.createElement('div');
      wr.id = 'lw-zoom-img-wrap';
      wr.style.cssText = 'overflow:hidden !important;';

      var im = document.createElement('img');
      im.id = 'lw-zoom-img';
      im.style.cssText = 'transition:transform 0.3s ease,opacity 0.3s ease;';
      wr.appendChild(im);

      /* Pfeile direkt auf dem Sheet (nicht im img-wrap), damit sie bei Slide nicht verschwinden */
      var ar = document.createElement('div');
      ar.id = 'lw-zoom-arrows';
      ar.style.cssText = 'position:absolute;left:0;right:0;top:0;bottom:0;pointer-events:none;display:flex;align-items:center;justify-content:space-between;padding:0 8px;z-index:10;';
      ar.innerHTML = '<button class="lw-zoom-arrow lw-zoom-arrow--prev">'+svg('prev')+'</button><button class="lw-zoom-arrow lw-zoom-arrow--next">'+svg('next')+'</button>';

      /* Zähler */
      var ct = document.createElement('div');
      ct.id = 'lw-zoom-counter';

      sh.appendChild(hd);
      sh.appendChild(wr);
      sh.appendChild(ar);
      sh.appendChild(ct);

      /* Vorladen: NUR Vorgaenger und Nachfolger, und erst wenn das gezeigte Bild da ist. Alle 13 auf einmal
         (so stand es hier) stellten die eine Datei, auf die der Kunde wartet, hinten an. */
      function sheetUrl(el){ return bildUrl(el, window.innerWidth-32, window.innerHeight*0.58); }
      function nachbarn(i){
        for (var d=1; d>=-1; d-=2){
          var s2=allItems[(i+d+tot)%tot].querySelector('img');
          if(s2) laden(sheetUrl(s2), null, true);
        }
      }

      var sliding = false;

      function ld(idx, dir) {
        if (sliding) return;
        /* Vor dem frueh abbrechenden Zweig darunter, damit auch der erste
           Aufruf ohne Animation den Pfeil richtig setzt. */
        firstOff(ar.querySelector('.lw-zoom-arrow--prev'), idx);
        if (!dir) {
          /* Erster Aufruf ohne Animation */
          var src = allItems[idx].querySelector('img');
          if (src) { var u0 = sheetUrl(src); zeige(im, src, null, u0); laden(u0, function(){ nachbarn(idx); }); }
          ct.textContent = (idx+1)+'/'+tot;
          scrollTo(idx);
          return;
        }
        sliding = true;

        var nextSrc = allItems[idx].querySelector('img');
        var newUrl = nextSrc ? sheetUrl(nextSrc) : '';

        /* Positionen messen */
        var imgRect = im.getBoundingClientRect();
        var wrRect = wr.getBoundingClientRect();
        var offTop = imgRect.top - wrRect.top;
        var offLeft = imgRect.left - wrRect.left;
        var w = imgRect.width;

        /* Zweites Bild erstellen, exakt neben dem aktuellen */
        var im2 = document.createElement('img');
        if (nextSrc) zeige(im2, nextSrc, null, newUrl);
        var startX = dir === 'next' ? w : -w;
        im2.style.cssText = 'position:absolute;top:'+offTop+'px;left:'+offLeft+'px;width:'+w+'px;height:'+imgRect.height+'px;object-fit:contain;border-radius:12px;display:block;transform:translateX('+startX+'px);transition:transform 0.4s ease;pointer-events:none;';

        wr.appendChild(im2);
        im2.offsetHeight;

        /* Beide gleichzeitig sliden */
        var shift = dir === 'next' ? -w : w;
        im.style.transition = 'transform 0.4s ease';
        im.style.transform = 'translateX('+shift+'px)';
        im2.style.transform = 'translateX(0)';

        ct.textContent = (idx+1)+'/'+tot;

        setTimeout(function(){
          if (nextSrc) { zeige(im, nextSrc, null, newUrl); laden(newUrl, function(){ nachbarn(idx); }); }
          im.style.transition = 'none';
          im.style.transform = '';
          im2.remove();
          scrollTo(idx);
          sliding = false;
        }, 420);
      }

      function cls() {
        bd.remove();
        sh.remove();
      }

      cb.addEventListener('click', cls);
      bd.addEventListener('click', cls);
      bd.addEventListener('touchend', function(e){
        if(e.target===bd){e.preventDefault();cls();}
      });
      sh.addEventListener('click', function(e){ e.stopPropagation(); });
      sh.addEventListener('touchend', function(e){ e.stopPropagation(); });

      /* Pfeile im Popup */
      ar.querySelector('.lw-zoom-arrow--prev').addEventListener('click',function(e){
        e.preventDefault();e.stopPropagation();
        ci=ci<=0?tot-1:ci-1; ld(ci,'prev');
      });
      ar.querySelector('.lw-zoom-arrow--next').addEventListener('click',function(e){
        e.preventDefault();e.stopPropagation();
        ci=ci>=tot-1?0:ci+1; ld(ci,'next');
      });

      /* Swipe im Popup */
      var tx=0;
      wr.addEventListener('touchstart',function(e){tx=e.changedTouches[0].screenX;},{passive:true});
      wr.addEventListener('touchend',function(e){
        var d=tx-e.changedTouches[0].screenX;
        if(Math.abs(d)>50){
          if(d>0){ ci=ci>=tot-1?0:ci+1; ld(ci,'next'); }
          else{ ci=ci<=0?tot-1:ci-1; ld(ci,'prev'); }
        }
      },{passive:true});

      document.body.appendChild(bd);
      document.body.appendChild(sh);

      ld(si);
    }
  }

  /* ===== INIT ===== */
  function init() {
    if (isMobile) initMobile();
    else initDesktop();
  }
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
  else init();
})();